// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BysS9{min-height:100vh;width:100%;background:#f5f5f5}.BysS9.snM2k{padding-bottom:80px}.USkPP{flex:1;max-width:480px;border-right:1px solid #e0e0e0}.USkPP.Erj_x{max-width:100%;border-right:none;border-bottom:1px solid #e0e0e0}.eAoXL{flex:1;padding:32px;display:flex;flex-direction:column}.eAoXL.RAb5u{padding:16px}.y9mwK{flex:1;overflow-y:auto;min-height:0}.O0ru1{position:sticky;bottom:0;padding-top:16px}.a_zCb{position:fixed;bottom:0;left:0;right:0;padding:16px;background:#fff;border-top:1px solid #e0e0e0;z-index:10}.R_hyk,.P3515{display:flex;align-items:center;justify-content:center;width:100%;min-height:100vh;padding:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `BysS9`,
	"pageMobile": `snM2k`,
	"leftPanel": `USkPP`,
	"leftPanelMobile": `Erj_x`,
	"rightPanel": `eAoXL`,
	"rightPanelMobile": `RAb5u`,
	"rightPanelScrollable": `y9mwK`,
	"actionFooter": `O0ru1`,
	"mobilePayNowSticky": `a_zCb`,
	"skeleton": `R_hyk`,
	"errorState": `P3515`
};
export default ___CSS_LOADER_EXPORT___;
